import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiLocationCodes } from 'modules/api';

export const fetchCountries = createAsyncThunk(
  'codes/fetchCountries',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiLocationCodes.getCountries();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const fetchCitiesByCountryCode = createAsyncThunk(
  'codes/fetchCitiesByCountryCode',
  async (countryCode: string, { rejectWithValue }) => {
    try {
      const response = await ApiLocationCodes.getCitiesByCountryCode(
        countryCode,
      );
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
